import React, { useState } from "react";
import "./index.scss";
import contentHelper from "utilities/contentHelper";
import { TOKENS } from "utilities/constants";
import { OutlinedInput } from "@mui/material";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import moment from "moment";
import { format } from "date-fns";

import DatePicker , { registerLocale } from "react-datepicker";
import commonUtilities from "utilities/common";
import { withLocalizer } from "utilities/withLocalizer";
import fr from "date-fns/locale/fr";

import "react-datepicker/dist/react-datepicker.css";

const EditableText = (props) => {

    const { languageCode, placeHolderObjects, prefixKey, allEditable, enable, text, handleUpdate } = props;

    const [editedValues, setEditedValues] = useState({});
    const [editing, setEditing] = useState(null);
    
    registerLocale("fr", fr); 

    const handleChange = (e, index, tag) => {
        const input = e.target.value;
        updateValue(input, index, tag);
    };

    const handleDateChange = (date, index, tag, tagIndex) => {
        const input = format(date, "dd MMM yyyy");
        updateValue(input, index, tag);
        handleUpdate(index, tag, input, tagIndex);
    };

    const updateValue = (input, index, tag) => {
        let pattern = /^-?\d+$/;
        if(tag.includes("MONEY")) {
            pattern = /^\$?\d{1,3}(,\d{3})*(\.\d{0,2})?$|^\$?\d+(\.\d{0,2})?$/;
        }
        
        if (input === "" || contentHelper.hasMatchTag(tag, [TOKENS.DATE]) || pattern.test(input)) {
            setEditedValues({ ...editedValues, [contentHelper.getHolderKey(index, tag)]: input });
        }
    };

    const toFloat = (value) => {
        const num = parseFloat(value.replace(",", ""));
        return isNaN(num) ? null : num;
    };

    const handleBlur = (e, index, tag, tagIndex) => {
        let input = e.target.value;
        // if(contentHelper.hasMatchTag(tag, ["MONEY"])) {
        //     const pattern = /\.$/;
        //     if (pattern.test(input)) {
        //         input = input + "0";
        //     }
        // }
        if(handleUpdate) {
            handleUpdate(index, tag, input, tagIndex);
        }
        setEditing(null);
    };

    const parseText = () => {
        let parts = text.split(/(\{\{.*?\}\})/g);
        let tagIndex = -1;
        return parts.map((part, index) => {
            const match = part.match(/\{\{(.*?)\}\}/);
            if (match) {
                
                tagIndex = tagIndex + 1;
                const tagIndexOnEvent = tagIndex;
                const placeHolderObject = placeHolderObjects[tagIndex];
                const holderObj = placeHolderObject?.data || contentHelper.getPlaceHolderObject(match[0]) || {}; // match[0] is full holder

                if(holderObj.tag && (contentHelper.hasMatchTag(holderObj.tag, [TOKENS.NUM, TOKENS.DATE, TOKENS.INT, TOKENS.MONEY, TOKENS.SUM, TOKENS.VAR, TOKENS.SUFFIX]))) {
                    if(contentHelper.tagEqual(holderObj.tag, TOKENS.SUM)) {
                        return contentHelper.getSumValue(placeHolderObject, placeHolderObjects) || "";
                    }
                    if(contentHelper.tagEqual(holderObj.tag, TOKENS.INT)) {
                        return holderObj.value || "";
                    }
                    if(contentHelper.tagEqual(holderObj.tag, TOKENS.VAR)) {
                        return "";
                    }
                    if(contentHelper.tagEqual(holderObj.tag, TOKENS.SUFFIX)) {
                        return contentHelper.getSuffix(languageCode, placeHolderObject, placeHolderObjects) || "";
                    }
                    const tag = holderObj.tag;
                    const direction = holderObj.direction || TOKENS.NONE;
                    const defaultValue = holderObj.default;
                    const holderKey = contentHelper.getHolderKey(index, tag);
                    let className = "editable-content" + (contentHelper.hasMatchTag(tag, [TOKENS.DATE]) ? " date" : "");
                    let errorClassName = (enable) ? " error" : "";
                    let value = "";
                    if(editedValues[holderKey] !== undefined) {
                        value = editedValues[holderKey] || "";
                    }
                    else{
                        value = holderObj.value || "";
                    }
        
                    let toolTipContent = "";
                    let dateValue = new Date();
                    let minDate = null;
                    let maxDate = null;
        
                    if(contentHelper.hasMatchTag(tag, [TOKENS.DATE])) {
                        dateValue = (value === "") ? new Date() : moment(value).toDate();
                        let dateDefaultValue = (defaultValue === "") ? new Date() : moment(defaultValue).toDate();
                        if(contentHelper.hasMatchTag(direction, [TOKENS.INC, TOKENS.DEC])) {
                            if(contentHelper.hasMatchTag(direction, [TOKENS.INC])) {
                                minDate = dateDefaultValue;
                            }
                            else{
                                maxDate = dateDefaultValue;
                            }
                        }
                    }
                    else{
                        if(value === "") {
                            className = className + errorClassName;
                            toolTipContent = enable ? props.localize("qma-editable-text-field-required-tooltip") : "";
                        }
                        else {
                            if(contentHelper.hasMatchTag(tag, [TOKENS.NUM, TOKENS.MONEY])) {
                                let _defaultValue = toFloat(defaultValue) || 0; 
                                if(commonUtilities.isLeadingCorrectZero(value)) {
                                    let _value = toFloat(value) || 0;
                                    if(_value !== _defaultValue && (contentHelper.hasMatchTag(direction, [TOKENS.INC, TOKENS.DEC]))) {
                                        if(contentHelper.hasMatchTag(direction, [TOKENS.INC])) {
                                            className = className + ((_value >= _defaultValue) ? "" : errorClassName);
                                        }
                                        else{
                                            className = className + ((_value <= _defaultValue) ? "" : errorClassName);
                                        }
                                        if(className.includes("error")) {
                                            toolTipContent = (contentHelper.hasMatchTag(direction, [TOKENS.INC])) ? props.localize("qma-editable-text-field-inc-tooltip") : props.localize("qma-editable-text-field-dec-tooltip");
                                        }
                
                                    }
                                }
                                else {
                                    className = className + errorClassName;
                                    toolTipContent = enable ? props.localize("qma-number-not-valid") : "";
                                }
                                
                            }
                        }
                    }
                    
                    let toolTipId = "editable-text-tooltip-" + index;
                    let showToolTip = className.includes("error") ? true : false;
        
                    return (allEditable || editing && (editing === holderKey)) ? (
                        contentHelper.hasMatchTag(tag, [TOKENS.DATE]) ? 
                            <span key={prefixKey + "-" + index} className={className}>
                                <DatePicker 
                                    className="custom-date-date-picker" 
                                    dateFormat="dd MMM yyyy"
                                    width="100%"
                                    locale={ languageCode?.toLowerCase() === "fr" ? fr :  null}
                                    disabled={allEditable && !enable}
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    selected={dateValue}
                                    onChange={(date) => handleDateChange(date, index, tag, tagIndexOnEvent)}
                                /> 
                            </span>
                            :
                            <span key={prefixKey + "-" + index} className={className}>
                                <OutlinedInput
                                    type="text"
                                    data-tooltip-id={toolTipId}
                                    data-tooltip-content={toolTipContent}
                                    readOnly={!allEditable && !editing}
                                    disabled={allEditable && !enable}
                                    name={"editable-text-" + index}
                                    id={"outlined-editable-text-" + index}
                                    value={value ?? ""}
                                    inputProps={{ maxLength: 13 }}
                                    onBlur={(event) => handleBlur(event, index, tag, tagIndexOnEvent)}
                                    onClick={() => { 
                                        if(allEditable) {
                                            setEditing(holderKey);
                                        }
                                    }}
                                    onChange={(event) => handleChange(event, index, tag)}
                                    onKeyPress={(event) => {
                                        if (event.key === "Enter") {
                                            //console.log("Enter key pressed!");
                                            handleBlur(event, index, tag, tagIndexOnEvent);
                                        }
                                    }}
                                    aria-describedby="outlined-adult-percent"
                                >
                                </OutlinedInput>
                                <Tooltip 
                                    id={toolTipId}
                                    place="top-end"
                                    isOpen={showToolTip}
                                />
                            </span>
                       
                    ) : (
                        <span
                            key={prefixKey + "-" + index} 
                        >
                            <span 
                                onClick={() => setEditing(holderKey)} 
                                className={className} 
                                data-tooltip-id={toolTipId}
                                data-tooltip-content={toolTipContent}
                            >
                                {value}
                            </span>
                            <Tooltip 
                                id={toolTipId}
                                place="top-end"
                                isOpen={showToolTip}
                            />
                        </span>
                    ); 
                }
            }
            return commonUtilities.parseHtml(part, "span", { key: prefixKey + "-" + index });
        });
    };
    return (
        <div className="editable-text">
            {parseText()}
        </div>);
};

export default withLocalizer(EditableText);